import { Configuration, LogLevel } from "@azure/msal-browser"

const AzureActiveDirectoryAppClientId: any =
  process.env.REACT_APP_AZURE_ACTIVE_DIRECTORY_APP_CLIENT_ID

const AzureRedirectUrl: any =
  process.env.REACT_APP_AZURE_ACTIVE_DIRECTORY_APP_REDIRECT_URL

const isIE = () => {
  return (
    window.navigator.userAgent.indexOf("MSIE ") > -1 ||
    window.navigator.userAgent.indexOf("Trident/") > -1
  )
}

export const MSAL_CONFIG: Configuration = {
  auth: {
    clientId: AzureActiveDirectoryAppClientId,
    redirectUri: AzureRedirectUrl,
    authority: "https://login.microsoftonline.com/common"
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: isIE()
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            return
          case LogLevel.Info:
            return
          case LogLevel.Verbose:
            return
          case LogLevel.Warning:
            return
        }
      }
    }
  }
}
